import React, { Component } from 'react'
import { AwardFileDetail } from 'containers/forms/awards'
import { meta } from 'helpers/decorators'
import { apiAwards, apiCodeLists } from 'helpers/decorators/api'

@meta({
  title: 'Award file'
})
@apiAwards({
  fileDetail: true,
  updateFile: true
})
@apiCodeLists(['activitySections'])
class AwardFile extends Component {
  render() {
    return (
      <AwardFileDetail {...this.props} />
    )
  }
}

export default AwardFile
